import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  SxProps,
} from '@mui/material';

import { Close as CloseIcon } from '@mui/icons-material';
import { TP_COLORS } from '../../../../../constants';

const actionButtonStyles: SxProps = {
  width: '120px',
  height: '40px',
  fontSize: '12px',
  fontWeight: 600,
  borderRadius: '6px',
};

interface DeleteConfirmationModalProps {
  open: boolean;
  title: string;
  onSubmit: () => void;
  onClose: () => void;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  open,
  title,
  onSubmit,
  onClose,
}) => {
  return (
    <Dialog
      maxWidth="sm"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { padding: '20px', borderRadius: '20px' } }}
    >
      <Stack alignItems="flex-end">
        <IconButton onClick={onClose}>
          <CloseIcon sx={{ color: '#000000' }} />
        </IconButton>
      </Stack>
      <DialogTitle
        sx={{
          color: TP_COLORS.gray.darken,
          textAlign: 'center',
          fontWeight: '700',
          fontSize: '28px',
        }}
      >
        Are you sure ?
      </DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <DialogContentText
          textAlign="center"
          color={TP_COLORS.gray.darken}
          marginBottom="20px"
        >
          Do you want to remove selected {title}?
        </DialogContentText>
        <DialogActions>
          <Button
            disableElevation
            variant="contained"
            color="inherit"
            onClick={onClose}
            sx={{
              ...actionButtonStyles,
              backgroundColor: TP_COLORS.border.color1,
            }}
          >
            Dismiss
          </Button>
          <Button
            disableElevation
            variant="contained"
            color="error"
            onClick={onSubmit}
            sx={{
              ...actionButtonStyles,
              color: TP_COLORS.white,
              backgroundColor: TP_COLORS.orange.light,
            }}
          >
            Remove
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
